<div class="container-financie">
  <div class="right">
    <div class="content-financie">
      <div class="titulo">
        <h2>
          Financie seu imóvel<br>
          em segurança com<br>
          nossos consultores
        </h2>

        <p class="sub-titulo-info">
          Somos credenciados como correspondente imobiliário<br>
          da Caixa Econômica Federeal e fazemos serviço completo,<br>
          desde a reunião de documentação das partes, aprovação<br>
          de crédito até o encaminhamento do processo
        </p>

        <div class="div-btn-financie">
          <img style="height: 80px;" class="img" src="../../assets/selo_caixa.png" alt="" />
          <button type="button" class="btn-consultor" (click)="acessaContato()">Fale com um consultor</button>
        </div>
      </div>
    </div>
  </div>

  <div class="right-first">
    <img src="../../assets/acessando-mulher-com-notebook-2.jpg" alt="" />
  </div>
</div>